<template>
  <div>
    <div class="browse" v-if="productCategory.length">
      <div
        @click="triggerMenuModal($event)"
        class="browsemenu d-flex justify-content-center align-items-center"
        :class="[getPositionClass]"
      >
        <img
          :src="staticImgBaseUrl + '/images/global/browseicon.svg'"
          class="browseicon"
        />
        <p class="fs-14 bold pl8">{{ browseMenuText }}</p>
      </div>
    </div>
    <!-- menu popup -->
    <!-- <bottom-bar-menu-modal
      class="menupopup"
      v-if="showMenuModal"
      @close-menu-modal="closeModalM()"
      :showModal="showMenuModal"
    ></bottom-bar-menu-modal> -->
  </div>
</template>

<script>
import BottomBarMenuModal from "./BottomBarMenuModal.vue";
import { keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import localStorageFunc from "../helpers/localStorageFunc";
import {
  imgBaseUrl,
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import { EVENT_CLICK_BOTTOM_STICKY_MENU } from "../helpers/analyticsEvents";
export default {
  name: "BrowseMenu",
  components: {
    BottomBarMenuModal,
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      showMenuModal: false,
      staticImgBaseUrl,
      browseMenuText: "Menu",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.browseMenuText = this.modulePropsData?.browseMenuText;
  },
  methods: {
    triggerMenuModal(e) {
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_SHOULD_SHOW_ALL_PRODUCT_CATEGORIES,
      //   true
      // );
      // document.body.classList.add("body-stop-scroll-mobile");
      // this.showMenuModal = true;
      EVENT_CLICK_BOTTOM_STICKY_MENU();
      let url =
        projectBasePathWithFolder +
        "/menu/" +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();
      url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
      window.location.href = url;
    },
    closeModalM() {
      this.showMenuModal = false;
    },
  },
  computed: {
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    isNotificationVisible() {
      return this.$store.state.Notification.notificationVisibilityStatus;
    },
    getNotificationPosition() {
      return this.$store.state.Notification.notificationPosition;
    },
    getPositionClass() {
      if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom-big"
      ) {
        return "move-up-inline-cart-big";
      } else if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom"
      ) {
        return "move-up-inline-cart";
      } else if (
        this.isNotificationVisible &&
        this.getNotificationPosition == "show-notif-bottom-big"
      ) {
        return "move-up-inline-big";
      } else if (
        this.isNotificationVisible &&
        this.getNotificationPosition == "show-notif-bottom"
      ) {
        return "move-up-inline";
      } else if (this.cartQuantity > 0) {
        return "move-up";
      }
      return "";
    },
    // menuExists(){
    //   return Object.keys(this.$store.state.ProductItems.products).length;
    // }
    productCategory() {
      return this.$store.state.ProductItems.productCategory;
    },
  },
};
</script>
<style></style>
